import {
  Button,
  FormField,
  IconButton,
  Spacer,
  SvgArrowLeft,
  Text,
  TextInput,
} from '@loomhq/lens';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import { SUCCESS } from 'constants/error-severities';
import { ENTER } from 'constants/keyCodes';
import { postResetPasswordCreator } from 'creators/resetPassword';

import * as validate from 'validate';

import AnonCommentFooter from '../share-signup-signin/anon-comment-footer';
import { showErrorBar } from '../../../../actions/errorBar';

const ResetPassword = ({ backClickHandler }) => {
  const dispatch = useDispatch();
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');

  const handleEmailInput = e => {
    setEmail(e.target.value);
    setError('');
  };

  const handleResetPassword = () => {
    if (!validate.email(email)) {
      setError('Please enter a valid email');

      return;
    }

    dispatch(postResetPasswordCreator(email));
    dispatch(showErrorBar(SUCCESS, 'Email en route. See you in a minute!'));
  };

  return (
    <>
      <div className="flex">
        <Spacer right={1}>
          <IconButton
            onClick={backClickHandler}
            icon={<SvgArrowLeft />}
            altText="Go back"
          />
        </Spacer>
        <Text isInline size="xlarge" fontWeight="bold">
          Reset your password
        </Text>
      </div>

      <Spacer top={5} />

      <FormField label="Email address" labelFor="email" errorMessage={error}>
        <TextInput
          id="email"
          type="email"
          placeholder="Enter your email"
          value={email}
          onChange={handleEmailInput}
          onKeyDown={e => {
            if (e.keyCode === ENTER) {
              handleResetPassword();
            }
          }}
        />
        <Spacer top="0.625rem" />
        <Button variant="primary" hasFullWidth onClick={handleResetPassword}>
          Reset password
        </Button>
      </FormField>

      <Spacer top={6} />

      <AnonCommentFooter isFooter={true} />
    </>
  );
};

export default ResetPassword;
